import React from "react";
import { Link } from "react-router-dom";
import styles from './panels.module.css'

import rusayl from '../../images/rusayl.jfif'
import raysut from '../../images/raysut.jfif'
import suhar from '../../images/suhar.jfif'
import alBuraimi from '../../images/al-buraimi.jfif'
import samail from '../../images/samail.jfif'
import alMazunahFreeZone from '../../images/al-mazunah-free-zone.jfif'
import nizwa from '../../images/nizwa.jfif'
import sur from '../../images/sur.jfif'
import knowledgeOasisMuscat from '../../images/knowledge-oasis-muscat.jfif'
import ibri from '../../images/ibri.jfif'
import alMudhaibi from '../../images/al-mudhaibi.jfif'
import mahas from '../../images/mahas.jfif'

export default function Panels() {
    const w = 150, ww = 320;
    return (
        <div className={styles.panels}>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.71deg, rgba(76, 42, 107, 0.6) 39.32%, rgba(230, 159, 106, 0) 100%), url(${rusayl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 25% 0'
                    }}>
                    Rusayl
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.39deg, rgba(180, 70, 84, 0.75) 38.02%, rgba(76, 42, 107, 0) 100.05%), url(${raysut})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 25% 0'
                    }}>
                    Raysut
                </Link>
            </div>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.39deg, rgba(230, 159, 106, 0.75) 38%, rgba(180, 70, 84, 0) 100%), url(${suhar})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 25% 0'
                    }}>
                    Suhar
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.39deg, rgba(76, 42, 107, 0.75) 38.02%, rgba(76, 42, 107, 0) 100.05%), url(${alBuraimi})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 25% 0'
                    }}>
                    Al Buraimi
                </Link>
            </div>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.39deg, rgba(180, 70, 84, 0.75) 38.02%, rgba(76, 42, 107, 0) 100.05%), url(${samail})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 15% 0'
                    }}>
                    Samail
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.39deg, rgba(230, 159, 106, 0.75) 38.04%, rgba(76, 42, 107, 0) 100.04%), url(${alMazunahFreeZone})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 0 0'
                    }}>
                    Al Mazunah <br />Free Zone
                </Link>
            </div>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.39deg, rgba(76, 42, 107, 0.75) 38.02%, rgba(76, 42, 107, 0) 100.05%), url(${nizwa})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 15% 0'
                    }}>
                    Nizwa
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.39deg, rgba(180, 70, 84, 0.75) 38%, rgba(230, 159, 106, 0) 100%), url(${sur})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 50% 25%'
                    }}>
                    Sur
                </Link>
            </div>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.39deg, rgba(230, 159, 106, 0.75) 38%, rgba(76, 42, 107, 0) 100%), url(${knowledgeOasisMuscat})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 0 0'
                    }}>
                    Knowledge <br />Oasis muscat
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.68deg, rgba(76, 42, 107, 0.75) 38%, rgba(180, 70, 84, 0) 100%), url(${ibri})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 50% 0'
                    }}>
                    Ibri
                </Link>
            </div>
            <div className={styles.group}>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: ww,
                        backgroundImage: `linear-gradient(102.39deg, rgba(180, 70, 84, 0.75) 38%, rgba(230, 159, 106, 0) 100%), url(${alMudhaibi})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 0 0'
                    }}>
                    Al-Mudhaibi
                </Link>
                <Link to="/map" className={styles.panel}
                    style={{
                        width: w,
                        backgroundImage: `linear-gradient(134.11deg, rgba(230, 159, 106, 0.75) 37%, rgba(51, 32, 68, 0) 97.38%), url(${mahas})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '0 0, 45% 0'
                    }}>
                    Mahas
                </Link>
            </div>
        </div>
    );
}